import { get } from "lodash";

import Label from "@/components/UI/Label";

type ReadonlyDischargeClasses = {
  col?: string;
  colReadonly?: string;
};

type ReadonlyDischargeProps = {
  classes?: ReadonlyDischargeClasses;
  discharge: Record<string, unknown>;
};

export function ReadonlyDischarge({ classes, discharge }: ReadonlyDischargeProps) {
  const additional_discharge_information = get(discharge, "additional_discharge_information", "");
  const discharge_date = get(discharge, "discharge_date", "");
  const discharge_type = get(discharge, "discharge_type", "");

  return (
    <>
      <div className={classes?.colReadonly ? "row mx-1" : "w-100 d-flex"}>
        <div className={classes?.colReadonly ?? "col-5 col-lg-2"}>
          <Label>Discharge Type</Label>
          <div className="mb-3">{discharge_type}</div>
        </div>

        <div className={classes?.colReadonly ?? "col-5 col-lg-2"}>
          <Label>Discharge Date</Label>
          <div className="mb-3">{discharge_date}</div>
        </div>
      </div>

      <div className={classes?.col ? "row mx-1" : "w-100 d-flex"}>
        <div className="col-12">
          <Label>Additional Discharge Information</Label>
          <div className="mb-3">{additional_discharge_information}</div>
        </div>
      </div>
    </>
  );
}
